import { ThemeEffect } from '@trenigo/brand';
import { LandingErrorBoundary } from './components/LandingErrorBoundary.js';
import type { PagePath } from './head.js';
import { CookiesPage } from './pages/CookiesPage.js';
import { LandingPage } from './pages/LandingPage.js';

/**
 * Kořen stromu webu - stejný pro předrenderování (entry-server.tsx) i hydrataci (entry-client.tsx).
 * Router není potřeba: web má jen dvě stránky a každá má vlastní předrenderované HTML.
 */
export function App({ page }: { page: PagePath }) {
  return (
    <LandingErrorBoundary>
      {/* Drží data-theme, color-scheme a theme-color v souladu s předvolbou po hydrataci (FR-04).
          První vykreslení zajistí theme-init.js ještě před Reactem. */}
      <ThemeEffect />
      {page === '/cookies' ? <CookiesPage /> : <LandingPage />}
    </LandingErrorBoundary>
  );
}
